export default {
  partner: 'partner_routes',
  profile: 'profiles'
}
